exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.bannerContent___1w3_c {\n  padding: 12px 20px;\n  text-align: center;\n}\n.bold___1vlLC {\n  font-weight: 500;\n  text-transform: none;\n}\n", ""]);

// exports
exports.locals = {
	"bannerContent": "bannerContent___1w3_c",
	"bold": "bold___1vlLC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/SingleSample/CustomizeWarning/styles.module.less
// module id = 1606
// module chunks = 71